import classNames from 'classnames';
import get from 'lodash.get';
import i18next from 'i18next';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import ButtonHoverAnimation from 'components/ButtonHoverAnimation';
import { PackageTitleTopBorder } from 'components/PackageTitleTopBorder';
import WideTease from 'components/WideTease';

import { package as PackagePropType } from 'lib/CustomPropTypes';

const POSSIBLE_METADATA = {
  ALLTEXT: 'seeAllText',
  ALLURL: 'seeAllUrl',
  BRAND: 'showBrand',
  DEK: 'showDek',
  EYEBROW: 'showEyebrow',
  LOADMORE: 'showLoadMore',
  LOGO: 'logoUrl',
  TEASE: 'showTeaseImage',
  TIMESTAMP: 'showTimestamp',
  TITLE: 'title',
};


const ITEMS_PER_PAGE = 20;
const INITIAL_NUMBER_ITEMS = 11;

export class Feeds extends Component {
  static propTypes = {
    additionalClasses: PropTypes.string,
    content: PackagePropType.isRequired,
    isRail: PropTypes.bool,
    pkgClassName: PropTypes.string,
    vertical: PropTypes.string.isRequired,
  };

  static defaultProps = {
    additionalClasses: '',
    isRail: false,
    pkgClassName: 'pkg feeds',
  };

  constructor(props) {
    super(props);
    const {
      content: {
        items,
      },
    } = props;

    const loadMore = this.getMetadata([POSSIBLE_METADATA.LOADMORE]);
    let numberOfItems = INITIAL_NUMBER_ITEMS;
    if (!loadMore || numberOfItems >= items.length) {
      numberOfItems = items.length;
    }

    this.state = {
      numberOfItems,
    };
  }

  componentDidUpdate(prevProps) {
    const {
      content: {
        items,
      },
    } = this.props;

    const {
      content: {
        items: prevItems,
      },
    } = prevProps;

    if (prevItems.length !== items.length) {
      this.updateNumberOfItems();
    }
  }

  updateNumberOfItems = () => {
    const {
      content: {
        items,
      },
    } = this.props;

    const loadMore = this.getMetadata([POSSIBLE_METADATA.LOADMORE]);

    let numberOfItems = INITIAL_NUMBER_ITEMS;
    if (!loadMore || numberOfItems >= items.length) {
      numberOfItems = items.length;
    }

    this.setState({
      numberOfItems,
    });
  }

  getMetadata = (path, defaultValue) => {
    const {
      content: {
        metadata,
      },
    } = this.props;

    return get(metadata, path, typeof defaultValue !== 'undefined' ? defaultValue : true);
  };

  isLastPage = () => {
    const {
      content: {
        items,
      },
    } = this.props;
    const {
      numberOfItems,
    } = this.state;


    return numberOfItems >= items.length;
  }

  onClickLoadMore = () => {
    const {
      content: {
        items,
      },
    } = this.props;
    const {
      numberOfItems,
    } = this.state;

    let numberToShow = numberOfItems + ITEMS_PER_PAGE;

    if (numberToShow >= items.length) {
      numberToShow = items.length;
    }

    this.setState({
      numberOfItems: numberToShow,
    });
  }

  renderArticleFeedsListItemContainer = (article, index, isLastArticle) => {
    if (!article) {
      return null;
    }
    const {
      id,
      computedValues,
      metadata: contentMetadata,
    } = article;
    const {
      content: {
        metadata: packageMetadata,
      },
      vertical,
      isRail,
    } = this.props;

    const title = get(packageMetadata, 'title');
    const hasPackageTitle = !!title;
    if (!computedValues) {
      return null;
    }

    const metadata = {
      ...packageMetadata,
      ...contentMetadata,
    };

    return (
      <WideTease
        key={id}
        hideBorder={!hasPackageTitle && index === 0}
        content={
          {
            ...article,
            metadata,
          }
        }
        isLastArticle={isLastArticle}
        vertical={vertical}
        isRail={isRail}
      />
    );
  };

  // Return the article list markup
  renderFeedsListItems = () => {
    const {
      content: {
        items,
      },
    } = this.props;
    const {
      numberOfItems,
    } = this.state;

    const itemsSliced = items.slice(0, numberOfItems);
    return (
      <div className="feeds__items-wrapper ph5 ph0-m">
        {itemsSliced.map((item, index) => this.renderArticleFeedsListItemContainer(
          item,
          index,
          this.isLastPage() && (numberOfItems - 1) === index,
        ))}
      </div>
    );
  };

  renderPackageTitle = () => {
    const title = this.getMetadata(POSSIBLE_METADATA.TITLE, null);
    const loadMore = this.getMetadata(POSSIBLE_METADATA.LOADMORE, true);
    // hide see all if load more
    const seeAllText = loadMore ? null : this.getMetadata(POSSIBLE_METADATA.ALLTEXT, null);
    const seeAllUrl = loadMore ? null : this.getMetadata(POSSIBLE_METADATA.ALLURL, null);
    const logoUrl = this.getMetadata(POSSIBLE_METADATA.LOGO, null);

    return (
      <PackageTitleTopBorder
        title={title}
        additionalClasses="feeds__header"
        seeAllText={seeAllText}
        seeAllUrl={seeAllUrl}
        logoUrl={logoUrl}
      />
    );
  };

  render() {
    const {
      pkgClassName,
      additionalClasses,
      content: {
        id,
      },
    } = this.props;


    const loadMore = this.getMetadata([POSSIBLE_METADATA.LOADMORE]);
    const showLoadButton = !this.isLastPage() && loadMore;

    return (
      <section
        data-packageid={id}
        className={classNames('feeds', pkgClassName, additionalClasses)}
      >
        <div className="feeds__wrapper">
          {this.renderPackageTitle()}
          {this.renderFeedsListItems()}

          {showLoadButton && (
            <div className="df justify-center mt6">
              <ButtonHoverAnimation
                type="button"
                additionalClasses="feeds__load-more-button"
                onClick={this.onClickLoadMore}
                title={i18next.t('Load More')}
                size="normal"
              />
            </div>
          )}
        </div>
      </section>
    );
  }
}
